import { Color, Mode, AnimationBuilder } from "@ionic/core";
import { ToastButton, ToastOptions } from "@ionic/angular";

export class ToastModel implements ToastOptions {
  message: string;
  header?: string = "";
  cssClass?: string = "toast-custom-class";
  duration?: number = 5000;
  position?: "top" | "bottom" | "middle" = "middle";
  icon?: string = "";
  keyboardClose?: boolean = true;
  buttons?: (ToastButton | string)[];
  translucent?: boolean;
  animated?: boolean;
  htmlAttributes?: { [key: string]: any };
  color?: Color;
  mode?: Mode;
  id?: string;

  enterAnimation?: AnimationBuilder;
  leaveAnimation?: AnimationBuilder;

  constructor(message: string, color: string = "success") {
    this.message = message;
    this.color = color;
  }
}
